import visit from "unist-util-visit"

const extractText = (string, start, end, type) => {
  const startLine = string.slice(0, start).split("\n")
  const endLine = string.slice(0, end).split("\n")
  return {
    type: type,
    value: string.slice(start, end),
    position: {
      start: {
        line: startLine.length,
        column: startLine[startLine.length - 1].length + 1
      },
      end: {
        line: endLine.length,
        column: endLine[endLine.length - 1].length + 1
      }
    }
  }
}

export const scriptType = () => {
  function transformer(tree) {
    visit(tree, ["html", "script"], (node, position, parent) => {
      const definition = []
      const regex = /<script\b[^>]*>(.*?)<\/script>/gm
      let lastIndex = 0
      let match

      while ((match = regex.exec(node.value as string)) !== null) {
        const value: string = match[0]
        const type = "script"

        if (match.index !== lastIndex) {
          const text = extractText(node.value, lastIndex, match.index, node.type)
          definition.push(text)
        }

        definition.push({
          type,
          value
        })

        lastIndex = match.index + value.length
      }

      if (lastIndex !== (node.value as string).length) {
        const text = extractText(node.value, lastIndex, (node.value as string).length, node.type)
        definition.push(text)
      }

      const last = parent.children.slice(position + 1)
      parent.children = parent.children.slice(0, position)
      parent.children = parent.children.concat(definition)
      parent.children = parent.children.concat(last)
    })
  }

  return transformer
}
